// The first priority in each array is the default for new settings.
export const BASE_SETTING_PRIO = {
  priority_level: 10,
  display_name: 'Base setting',
}

export const BASE_SETTING_PRIORITIES = [BASE_SETTING_PRIO]

export const PLANNED_DEVIATION_SETTING_PRIO = {
  priority_level: 20,
  display_name: 'Planned',
}

export const UNPLANNED_DEVIATION_SETTING_PRIO = {
  priority_level: 30,
  display_name: 'Unplanned',
}

export const DEVIATION_SETTING_PRIORITIES = [UNPLANNED_DEVIATION_SETTING_PRIO, PLANNED_DEVIATION_SETTING_PRIO]

export const FOLLOW_UP_SETTING_PRIO = {
  priority_level: 50,
  display_name: 'Follow-up',
}

export const SETTLEMENTS_SETTING_PRIO = {
  priority_level: 60,
  display_name: 'Settlements',
}

// A digital twin uid handed to the client by the backend can briefly respond 404 while the
// row replicates across database read replicas (the client may hit a replica that hasn't
// caught up yet). Retry the fetch over a ~30s window (10 retries × 3s; 11 total attempts)
// to absorb this replication delay before surfacing the error.
export const DIGITAL_TWIN_REPLICATION_RETRY_ATTEMPTS = 10
export const DIGITAL_TWIN_REPLICATION_RETRY_DELAY_MS = 3000
export const DIGITAL_TWIN_REPLICATION_RETRY_JITTER_RATIO = 0.2

// Sentry issue_type for a digital twin still 404ing after the replication window (a uid the
// backend handed out must exist, so a persistent 404 is an alarm, not expected "not found").
export const DIGITAL_TWIN_REPLICATION_TIMEOUT_ISSUE_TYPE = 'digital_twin_replication_timeout'
